import { render, staticRenderFns } from "./view_document.vue?vue&type=template&id=5d6ecfea&scoped=true"
import script from "./view_document.vue?vue&type=script&lang=js"
export * from "./view_document.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6ecfea",
  null
  
)

export default component.exports